module.exports = __webpack_public_path__ + "static/media/jason-human.bc08c7db.png";